// extracted by mini-css-extract-plugin
export default {"testResponseItemList":"TestResponseItemList_testResponseItemList__W7nqS","testResponseItem":"TestResponseItemList_testResponseItem__uKZmR"};